export default __webpack_public_path__ + "static/media/ddsu5168_4p_rs485_gw152.8ca6aeec.png";